// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GZdH","col":"styles_col__1Qv9p","actions":"styles_actions__3oaPK","conflict":"styles_conflict__24dje"};